export default `blog-toc-title = В этой статье
`;